import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { Capacitor } from "@capacitor/core";
import mixpanel from "mixpanel-browser";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routeList } from "../App";
import { storageKey } from "../configs/config";
import api from "../services/api";

export const PushNotificationHandler: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const setupListeners = async () => {

      // Add actual notification listeners
      await FirebaseMessaging.addListener("tokenReceived", async (event) => {
        console.log("Push registration success, token: " + event.token);
        localStorage.setItem(storageKey.deviceToken, event.token);
        try {
          await api.updateDeviceToken({ deviceToken: event.token });
        } catch (err) {
          console.error("Error sending token to backend", err);
        }
      });

      await FirebaseMessaging.addListener("notificationActionPerformed", (event) => {
        console.log("Push action performed: ", event);
        const data = event.notification.data as any;

        mixpanel.track("Push Opened", {
          push_type: data?.type,
          notification_id: data?.notification_id,
        });

        if (data?.type === "chat" && data.chatId) {
          navigate(`${routeList.chatWith}/${data.chatId}`);
        } else if (data?.type === "match") {
          navigate(`${routeList.chat}`);
        }
      });
    };

    setupListeners();

    return () => {
      // Cleanup listeners on unmount
      FirebaseMessaging.removeAllListeners();
    };
  }, [navigate]);

  return null;
};
